Auth = require 'app/scripts/db/auth'
trigger = require 'app/scripts/lib/util/event/trigger'
window.getAuthorization = ->
  type: 'cookie', token: Auth.myToken()
